function HomePageHandler(product = "", event, data) {
  const { metaData = {}, setData = {} } = data,
    {
      userId = "",
      name: userName = "",
      email: userEmail = "",
      mobile: userContact = "",
      balance = 0,
      role = "",
    } = metaData,
    {
      fixedTrip = {},
      flexiTrip = {},
      paxInfo = {},
      tripType: trip = "",
    } = setData,
    { pClass = "" } = paxInfo,
    { origin = {}, destination = {} } = fixedTrip,
    { selectedOption: selectedOptionOrigin = {} } = origin,
    { selectedOption: selectedOptionDestination = {} } = destination,
    {
      city: originCity = "",
      code: originCityCode = "",
      countryCode: originCountryCode = "",
      country: originCountry = "",
    } = selectedOptionOrigin,
    {
      city: destinationCity = "",
      code: destinationCityCode = "",
      countryCode: destinationCountryCode = "",
      country: destinationCountry = "",
    } = selectedOptionDestination;
  let tripType = "";
  trip == 0
    ? (tripType = "ONEWAY")
    : trip == 1
    ? (tripType = "ROUNDTRIP")
    : trip == 2
    ? (tripType = "MULTICITY")
    : "";
  const commonData = { Identity: userId, walletBalance: balance, role };
  let finalData = {};
  switch (event) {
    case "Login":
      finalData = { ...commonData };
      break;
    case "Search":
      finalData = {
        ...commonData,
        originCity,
        originCityCode,
        originCountry,
        originCountryCode,
        destinationCity,
        destinationCityCode,
        destinationCountryCode,
        destinationCountry,
        tripType,
        class: pClass,
      };
      break;
    case "PageView":
      finalData = { ...commonData };
      break;
    case "IncentiveBanner":
      finalData = { ...commonData };
      break;
    case "TransitVisa": {
      finalData = {
        Identity: userId,
      };
      break;
    }
  }
  return finalData;
}

module.exports = { HomePageHandler };
